
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Oropharyngeal_acancer",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Oropharyngeal_acancer.vue